import { z } from 'zod'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

export const botRunsSearchSchema = z.object({
  current: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().positive().max(100).catch(20),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z.string().trim().max(100).optional(),
  status: z.enum(['preview', 'queued', 'issued', 'sent', 'failed']).optional()
})
export const botRunsPersistence = createListQueryPersistence('super-mega:bot-runs:list-query', botRunsSearchSchema)
export type BotRunsSearch = z.infer<typeof botRunsSearchSchema>
